import { Flag, Zap, Globe2, Gem, Eye, Store } from "lucide-react";
import { useLang } from "@/i18n";
import { SectionHead, Reveal } from "@/components/common";

const ICONS = [Flag, Zap, Globe2, Gem, Eye, Store];

export function AboutCards() {
  const { t } = useLang();
  return (
    <section className="section-pad py-24" data-testid="about-section">
      <SectionHead eyebrow={t("about.eyebrow")} title={t("about.title")} sub={t("about.sub")} />
      <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {ICONS.map((Icon, i) => (
          <Reveal key={i} delay={i * 0.07}>
            <div className="card-surface group relative h-full overflow-hidden p-7" data-testid={`about-card-${i + 1}`}>
              <div aria-hidden="true" className="absolute -right-10 -top-10 h-32 w-32 rounded-full bg-gold/10 blur-2xl transition-opacity duration-500 group-hover:bg-neon/15" />
              <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-gold/30 bg-gold/10 transition-colors duration-300 group-hover:border-neon/50 group-hover:bg-neon/10">
                <Icon size={22} className="text-goldlight transition-colors duration-300 group-hover:text-neon" />
              </div>
              <h3 className="mt-6 font-heading text-lg font-bold uppercase tracking-wide text-paper">{t(`about.c${i + 1}t`)}</h3>
              <p className="mt-2 text-sm leading-relaxed text-mist">{t(`about.c${i + 1}d`)}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
